import { MaterialSymbols_200ExtraLight } from '@expo-google-fonts/material-symbols/200ExtraLight';

import type { AndroidSymbolWeight } from '../..';
const weight: AndroidSymbolWeight = {
  name: 'MaterialSymbols_200ExtraLight',
  font: MaterialSymbols_200ExtraLight,
};
export default weight;
